// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const BatSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'bat-idle',
    metadata: {
      frames: {
        'bat-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-1': {
          frame: {
            x: 116,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-2': {
          frame: {
            x: 232,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-3': {
          frame: {
            x: 348,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-4': {
          frame: {
            x: 464,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-5': {
          frame: {
            x: 580,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-6': {
          frame: {
            x: 696,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-7': {
          frame: {
            x: 812,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-8': {
          frame: {
            x: 928,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-9': {
          frame: {
            x: 1044,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-idle-10': {
          frame: {
            x: 1160,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/bat/idle.png',
        size: {
          w: 1276,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'bat-idle': [
          'bat-idle-0',
          'bat-idle-1',
          'bat-idle-2',
          'bat-idle-3',
          'bat-idle-4',
          'bat-idle-5',
          'bat-idle-6',
          'bat-idle-7',
          'bat-idle-8',
          'bat-idle-9',
          'bat-idle-10',
        ],
      },
    },
  },
  {
    name: 'bat-attack2',
    metadata: {
      frames: {
        'bat-attack2-0': {
          frame: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-1': {
          frame: {
            x: 116,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-2': {
          frame: {
            x: 232,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-3': {
          frame: {
            x: 348,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-4': {
          frame: {
            x: 464,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-5': {
          frame: {
            x: 580,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-6': {
          frame: {
            x: 696,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-7': {
          frame: {
            x: 812,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-8': {
          frame: {
            x: 928,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-9': {
          frame: {
            x: 1044,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-10': {
          frame: {
            x: 1160,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-11': {
          frame: {
            x: 1276,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-attack2-12': {
          frame: {
            x: 1392,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/bat/attack2.png',
        size: {
          w: 1508,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'bat-attack2': [
          'bat-attack2-0',
          'bat-attack2-1',
          'bat-attack2-2',
          'bat-attack2-3',
          'bat-attack2-4',
          'bat-attack2-5',
          'bat-attack2-6',
          'bat-attack2-7',
          'bat-attack2-8',
          'bat-attack2-9',
          'bat-attack2-10',
          'bat-attack2-11',
          'bat-attack2-12',
        ],
      },
    },
  },
  {
    name: 'bat-hurt',
    metadata: {
      frames: {
        'bat-hurt-0': {
          frame: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-hurt-1': {
          frame: {
            x: 116,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-hurt-2': {
          frame: {
            x: 232,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-hurt-3': {
          frame: {
            x: 348,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-hurt-4': {
          frame: {
            x: 464,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/bat/hurt.png',
        size: {
          w: 580,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'bat-hurt': [
          'bat-hurt-0',
          'bat-hurt-1',
          'bat-hurt-2',
          'bat-hurt-3',
          'bat-hurt-4',
        ],
      },
    },
  },
  {
    name: 'bat-dead',
    metadata: {
      frames: {
        'bat-dead-0': {
          frame: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-1': {
          frame: {
            x: 116,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-2': {
          frame: {
            x: 232,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-3': {
          frame: {
            x: 348,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-4': {
          frame: {
            x: 464,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-5': {
          frame: {
            x: 580,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-6': {
          frame: {
            x: 696,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
        'bat-dead-7': {
          frame: {
            x: 812,
            y: 0,
            w: 116,
            h: 64,
          },
          sourceSize: {
            w: 116,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 116,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/bat/dead.png',
        size: {
          w: 928,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'bat-dead': [
          'bat-dead-0',
          'bat-dead-1',
          'bat-dead-2',
          'bat-dead-3',
          'bat-dead-4',
          'bat-dead-5',
          'bat-dead-6',
          'bat-dead-7',
        ],
      },
    },
  },
];
